import React from 'react'

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '', email: '', phone: '', message: '', subject: '', contactFormLoading: false, contactFormDone: false
    }
  }

  handleChange = e => this.setState({ [e.target.name]: e.target.value });
  handleSubmit = e => {
    e.preventDefault()
    this.setState({ contactFormLoading: true })
    // split the firstname and lastname
    const name = this.state.name.split(' ')

    setTimeout(() => {
      this.setState({ contactFormLoading: false, contactFormDone: true,
        name: '', email: '', phone: '', message: '', subject: ''
      })
    }, 1500)
  }

  getContactFormButtonText = () => {
    if(this.state.contactFormDone) {
      return "Sent"
    }
    if(this.state.contactFormLoading && !this.state.contactFormDone) {
      return "Sending.."
    }
    return "Send"
  }
  render() {
    return (
      <form onSubmit={this.handleSubmit}>
							<div className="row">
								<div className="col-sm-6">
									<div className="form-group">
										<div className="controls">
											<input className="form-control" placeholder="Subject *" type="text" value={this.state.subject} name="subject" onChange={this.handleChange} />
										</div>
									</div>
								</div>
								<div className="col-sm-6">
									<div className="form-group">
										<div className="controls">
											<input className="form-control" id="contactFormPhone" placeholder="Phone" type="text" name="phone" value={this.state.phone} onChange={this.handleChange} />
										</div>
									</div>
								</div>
							</div>
							<div className="row mb10">
								<div className="col-sm-6">
									<div className="form-group">
										<div className="controls">
											<input className="form-control" placeholder="Your Name *" required="" type="text" name="name" value={this.state.name} onChange={this.handleChange} />
										</div>
									</div>
								</div>
								<div className="col-sm-6">
									<div className="form-group">
										<div className="controls">
											<input className="email form-control" placeholder="Email *" type="email" name="email" value={this.state.email} onChange={this.handleChange} />
										</div>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-12">
									<div className="form-group">
										<div className="controls">
											<textarea className="form-control" name="message" placeholder="Message *" rows="5" value={this.state.message} onChange={this.handleChange}></textarea>
										</div>
									</div>
								</div>
							</div>
							<div className="row mt15">
								<div className="col-sm-6">
    <div id="msgSubmit" className="h4 mt10 no-margin-bottom" style={{color: '#54dc11'}}>{this.state.contactFormDone && <span>Mission Accomplished</span>}</div>
								</div>
								<div className="col-sm-6 text-right">
									<button type="submit" disabled={this.state.contactFormLoading || this.state.contactFormDone} className="btn btn-default btn-lg">{this.getContactFormButtonText()}</button>
								</div>
							</div>
						</form>
    )
  }
}
  


// WEBPACK FOOTER //
// ./src/components/contactform.js